import makeStyles from '@mui/styles/makeStyles';
import { BREAKPOINTS, COLORS, HEIGHT_SIZE, Z_INDEX } from 'constants/styles';

export default makeStyles(
  {
    root: {
      overflow: 'hidden',
      position: 'fixed',
      zIndex: Z_INDEX.modal,
      width: '100%',
      height: '100%',
      top: 0,
    },
    background: {
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    mobileHeader: {
      display: 'none',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        display: 'flex',
        alignItems: 'center',
        height: HEIGHT_SIZE.header,
        padding: '0 24px',
      },
    },
    cancelButton: {
      border: 0,
      cursor: 'pointer',
      marginLeft: 'auto',
    },
    modal: {
      position: 'fixed',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',

      [`@media (max-width:${BREAKPOINTS.MD}px)`]: {
        overflow: 'auto',
        background: 'red',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        transform: 'none',
        backgroundColor: COLORS.bgColor,
      },
    },
  },
  { name: 'Modals' },
);
